import { type CalendarCell, buildMonthGrid } from '../lib/calendar.js'
import { invitation } from '../data/invitation.js'
import { koreanDateLine, monthNameEn, weddingMoment } from '../lib/weddingDate.js'
import styles from './CeremonyInfo.module.css'

const WEEKDAY_HEADS = ['일', '월', '화', '수', '목', '금', '토']

function dayColor(cell: CalendarCell): string {
  if (cell.isWedding) return '#FFFDF6'
  if (cell.weekday === 0) return 'var(--sunday)'
  if (cell.weekday === 6) return '#8B95A3'
  return 'var(--calendar-weekday-ink)'
}

export function CeremonyInfo() {
  const moment = weddingMoment(invitation.weddingAt)
  const grid = buildMonthGrid(moment.year, moment.month, moment.day)

  return (
    <div className={styles.wrap}>
      <div className={styles.divider}>
        <span className={styles.line} />
        <span className={styles.dot} />
        <span className={styles.line} />
      </div>
      <div className={styles.eyebrow}>wedding day</div>
      <h2 className={styles.title}>예식 안내</h2>
      <div className={styles.calendar}>
        <div className={styles.year}>{moment.year}</div>
        <div className={styles.month}>{monthNameEn(moment)}</div>
        <div className={styles.calHead}>
          {WEEKDAY_HEADS.map((label, i) => (
            <div
              key={label}
              className={styles.calHeadCell}
              style={{ color: i === 0 ? 'var(--sunday)' : 'var(--ink-2)' }}
            >
              {label}
            </div>
          ))}
        </div>
        <div className={styles.calGrid}>
          {grid.map((cell) => (
            <div
              key={cell.day}
              data-day={cell.day}
              className={styles.calCell}
              style={{ color: dayColor(cell) }}
            >
              {cell.isWedding && <span className={styles.badge} />}
              <span className={styles.calNum}>{cell.day}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.dateLine}>{koreanDateLine(moment)}</div>
      <div className={styles.venueLine}>
        {invitation.venue.name}, {invitation.venue.hall}
      </div>
      <div className={`${styles.divider} ${styles.dividerBottom}`}>
        <span className={styles.line} />
        <span className={styles.dot} />
        <span className={styles.line} />
      </div>
    </div>
  )
}
